export default __webpack_public_path__ + "static/media/cochin3.ae92fd77.jpg";